import { inject } from 'vue';
import { injectKey, ShowToastFunc } from './typings';


export function useToast() {
  const showToast = inject(injectKey) as ShowToastFunc;

  function showSuccessToast(content: string) {
    return showToast({
      type: 'success',
      content,
    });
  }

  function showErrorToast(content: string) {
    return showToast({
      type: 'error',
      content,
    });
  }
  return {
    toast: showToast,
    success: showSuccessToast,
    error: showErrorToast,
  };
}
